import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-jqeasing-page-configurator',
	templateUrl:'./JQEasingPageConfiguratorPluginCompPage.html',
	styles: [],
	styleUrls:['./JQEasingPageConfiguratorPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQEasingPageConfiguratorPluginCompPage
{
	mdContent_994 = `\`\`\`java
import com.jwebmp.plugins.easingeffects.JQEasingPageConfigurator;
\`\`\``;
	mdContent_995 = `\`\`\`java
JQEasingPageConfigurator.setEnabled(false);
\`\`\``;
	mdContent_996 = `\`\`\`java
module com.myapp {
    requires com.jwebmp.plugins.easingeffects;
}
\`\`\``;
}
